var React = require('react/addons');
var cx = require('classnames');


var ToggleSelect = React.createClass({
  render() {
    var {options} = this.props;

    options = options.map(this.renderOption);

    var classes = cx({
      'ofs-Input': true,
      'ofs-Input--toggle': true
    });

    return (
      <div className={classes}>
        <input type="hidden" {...this.props} />
        {options}
      </div>
    );
  },

  onChange(value) {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  },

  renderOption(option) {
    const { className } = this.props;
    var width = 100 / this.props.options.length;

    var classes = cx({
      'ofs-Input__ToggleOption': true,
      'ofs-Input__ToggleOption--is-selected': option.value === this.props.value,
      [className]: true
    });

    var style = {
      width: width + '%'
    };

    return (
      <div style={style} key={option.value} className={classes} onClick={this.onChange.bind(null, option.value)}>
        {option.name}
      </div>
    );
  }
});

module.exports = ToggleSelect;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/inputs/toggle-select.jsx
 **/